import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"
import { AcrConfigurationTab } from "./AcrConfigurationTab"

export const AcrConfigurationPage = () => {
  const vendor = INTEGRATION_VENDORS.acr

  return (
    <ConfigurationPageTemplate
      vendor={vendor}
      config={<AcrConfigurationTab vendor={vendor} />}
      titleKey="integrations.configuration.acr.configurationTitle"
    />
  )
}
